import { useState } from "react";
import { useTranslate } from "@refinedev/core";
import { GlobeIcon, SettingsTileCard } from "@fawkes/ui";

import { GemeenteManagement } from "../GemeenteManagement";
import type { TileComponentProps } from "./types";

// Gemeente — municipality list + woonplaatsen. Organisatie context only. First migrated tile: the
// card opens the real master/detail screen (settings-gemeente), no longer the coming-soon dialog.
export const GEMEENTE_TILE_KEY = "gemeente";

const ITEM_KEYS = ["instellingen.item.gemeente"];

export function GemeenteTile({ context }: TileComponentProps) {
  const t = useTranslate();
  const [open, setOpen] = useState(false);
  if (context.type !== "organization") return null;
  return (
    <>
      <SettingsTileCard
        tileKey={GEMEENTE_TILE_KEY}
        icon={<GlobeIcon className="settings-tile-icon" width={16} height={16} />}
        title={t("instellingen.tile.gemeente.title")}
        description={t("instellingen.tile.gemeente.desc")}
        items={ITEM_KEYS.map((k) => t(k))}
        openLabel={t("instellingen.cta.open")}
        onOpen={() => setOpen(true)}
      />
      {open && <GemeenteManagement onBack={() => setOpen(false)} />}
    </>
  );
}
